import { Range } from "@abaco/map-web-module/src/modules/map-web-module/models/ThemeModels";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { Theme, LegendLayer } from "@abaco/map-web-module/src/modules/map-web-module/models/Layer";

export default class ThemeApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getLayerEntries(pk_cuaa: number, theme_code: string): Promise<Range[]>
    {
        const res = await this.http.get(`/map/api/v1/farms/${pk_cuaa}/themes/code/${theme_code}/entries`)
        return res.data
    }

    /*
    *
    * http://localhost:9090/siticatasto/dbgis-servlet/tl_viewers?connection=siti&oid=406926&scs=0&op=layers&prj_id=0&refdate=2022-05-05T15%3A20%3A01.938Z&view_context=ACTIVE_LAYERS&year=2022&black_listed_entities=LOT&_nc=1651763987863*/
/*
*
    * connection: siti
    oid: 406926
    scs: 0
    op: layers
    prj_id: 0
    refdate: 2022-05-05T15:20:01.938Z
    view_context: ACTIVE_LAYERS
    year: 2022
    black_listed_entities: LOT
    _nc: 1651763987863
* */

    public async getPlotLayer(pk_cuaa: number, campaign: number, prjId: number, rotation: number): Promise<LegendLayer | null>
    {
        const res = await this.http.get<{layers: LegendLayer[]}>(`/siticatasto/dbgis-servlet/tl_viewers`, {
            params: {
                connection: 'siti',
                oid: pk_cuaa,
                scs: 0,
                op: 'current',
                prj_id: prjId,
                refdate: new Date().toISOString(),
                view_context: 'ACTIVE_LAYERS',
                year: campaign,
            }
        })

        const plotLayers = res.data.layers.filter(legendLayer => legendLayer.layer_entity === "LOT")
        if(!plotLayers.length){
            return null;
        }
        if(plotLayers.length >= rotation - 1){
            return plotLayers[rotation - 1]
        }
        return plotLayers[0]
    }

    public async canViewTheme(pkCuaa: number): Promise<boolean> {
        const url = `/sitiagri-rest-api/api_basic/v1/user_registry/subjects/${pkCuaa}/module_competencies/BEST_PRACTICE/LOT_THEME_VIEW`;
        const res = await this.http.get(url);
        return res.data.result;
    }

    public async canUpdateTheme(pkCuaa: number): Promise<boolean> {
        const url = `/sitiagri-rest-api/api_basic/v1/user_registry/subjects/${pkCuaa}/module_competencies/BEST_PRACTICE/LOT_THEME_EDIT`;
        const res = await this.http.get(url);
        return res.data.result;
    }

    public async canCreateTheme(pkCuaa: number): Promise<boolean> {
        const url = `/sitiagri-rest-api/api_basic/v1/user_registry/subjects/${pkCuaa}/module_competencies/BEST_PRACTICE/LOT_THEME_ADMIN`;
        const res = await this.http.get(url);
        return res.data.result;
    }

    public async getLayerTheme(pk_cuaa: number, layer_code: string): Promise<Theme | null>
    {
        const data = (await this.http.get(`/map/api/v1/farms/${pk_cuaa}/themes/code/MANUAL`)).data;
        if(!data){
            return null;
        }

        const entries = await this.getLayerEntries(pk_cuaa, "MANUAL")

        return {
            ...data,
            name: data.code,
            description: data.descr,
            expression: '',
            fl_default: 0, // data.flDefault, 
            selected: false,
            expression_type: '',
            theme_id: data.themeId,
            entries: entries.map(el => {
                return {
                    ...el,
                    unique_value: el.codice || '',
                    colore: el.colore,
                    colorelinea: el.coloreLinea,
                    spessore: el.spessore,
                    type: '0'
                }
            })
        }
    }
}
